export const PAGE_HEADER_E2E_SELECTORS = {
    subTitle: 'page-header-subtitle',
} as const;
